/**
 * Shared flag for cross-domain session handshake state.
 * Prevents DomainEnforcer from redirecting while token exchange is in progress.
 */
let _active = false;

export function setCrossDomainHandshakeActive(v: boolean): void {
  _active = v;
}

export function isCrossDomainHandshakeActive(): boolean {
  return _active;
}
